import { Component } from '@theme/component';

/**
 * Pack-size picker for a product card: a radio per variant with its price beside it, and an
 * add-to-cart button below. Selecting a radio rewrites the hidden variant input of the card's
 * own product form, so the existing `product-form-component` performs the add - which also
 * means the cart drawer opens on add exactly as it does everywhere else in the theme.
 *
 * A product with a single variant renders the button with no rows, so nothing here runs for it.
 *
 * @extends {Component}
 */
class CasscadoPackPicker extends Component {
  /**
   * Points the form at the chosen variant. Bound through `on:change="/selectPack"`, which
   * carries no data segment, so the event is the only argument.
   *
   * The form's inputs and button belong to the nested `product-form-component`, which is the
   * closest component to them, so `refs` here never sees them - a ref lands on exactly one
   * component. They are queried from the subtree instead.
   *
   * @param {Event} event - The change event from the radio.
   */
  selectPack(event) {
    const input = event?.target;

    if (!(input instanceof HTMLInputElement) || !input.checked) return;

    const variantInput = /** @type {HTMLInputElement | null} */ (this.querySelector('input[name="id"]'));
    if (!variantInput) return;

    const { variantId, available } = input.dataset;

    if (variantId) variantInput.value = variantId;

    // An unavailable variant must not be addable, and the form must not post a stale id.
    const canAdd = available === 'true';
    variantInput.disabled = !canAdd;

    const submit = /** @type {HTMLButtonElement | null} */ (
      this.querySelector('[ref="addToCartButton"], button[type="submit"]')
    );

    if (submit) {
      submit.disabled = !canAdd;
      submit.setAttribute('aria-disabled', String(!canAdd));
    }
  }
}

if (!customElements.get('casscado-pack-picker')) {
  customElements.define('casscado-pack-picker', CasscadoPackPicker);
}
